import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="pt-20 pb-10 border-t transition-colors duration-300" style={{
    backgroundColor: 'var(--bg-primary)',
    color: 'var(--text-primary)',
    borderColor: 'var(--border-color)'
  }} data-id="element-38">
      <div className="container mx-auto px-6 md:px-12" data-id="element-39">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-40">
          <div className="col-span-1 md:col-span-2" data-id="element-41">
            <div className="flex items-center gap-2 mb-6" data-id="element-42">
              <img src="https://cdn.magicpatterns.com/uploads/eu7Fkf1LNP9nCJy7uYGBCL/image.png" alt="Junquito Gas Logo" className="h-16 object-contain mix-blend-multiply dark:mix-blend-normal dark:brightness-125" style={{
              background: 'transparent'
            }} data-id="element-43" />
            </div>
            <p className="max-w-md mb-8 transition-colors duration-300" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-44">
              Distribuidora de combustibles (GLP, Gasoil y Gasolina) y
              estaciones de servicio comprometidas con ofrecer productos de la
              más alta calidad. Nuestra gasolina es distribuida en colaboración
              con NEXT. Combustible confiable y seguro para sus vehículos,
              hogares y negocios.
            </p>
            <div className="flex gap-4" data-id="element-45">
              <a href="https://www.facebook.com/junquitogas/?locale=es_LA" target="_blank" rel="noopener noreferrer" className="text-sm font-bold uppercase tracking-wider hover:text-[#FCEE02] transition-colors" style={{
              color: 'var(--text-muted)'
            }} data-id="element-46">
                Facebook
              </a>
              <a href="https://www.instagram.com/junquitogas/" target="_blank" rel="noopener noreferrer" className="text-sm font-bold uppercase tracking-wider hover:text-[#FCEE02] transition-colors" style={{
              color: 'var(--text-muted)'
            }} data-id="element-47">
                Instagram
              </a>
              <a href="https://wa.me/18092472104" target="_blank" rel="noopener noreferrer" className="text-sm font-bold uppercase tracking-wider hover:text-[#FCEE02] transition-colors" style={{
              color: 'var(--text-muted)'
            }} data-id="element-48">
                WhatsApp
              </a>
            </div>
          </div>

          <div data-id="element-49">
            <h4 className="font-bold uppercase tracking-wider mb-6" style={{
            color: 'var(--accent-yellow-text)'
          }} data-id="element-50">
              Servicios
            </h4>
            <ul className="space-y-4 transition-colors duration-300" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-51">
              {['GLP de Alta Calidad', 'Gasolina (NEXT)', 'Gasoil Premium', 'Estaciones Certificadas'].map(item => <li key={item} data-id="element-52">
                  <a href="#" className="hover:text-[#FCEE02] transition-colors flex items-center gap-2" data-id="element-53">
                    <span className="w-1 h-1 bg-[#EC2424]" data-id="element-54" />
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-55">
            <h4 className="font-bold uppercase tracking-wider mb-6" style={{
            color: 'var(--accent-yellow-text)'
          }} data-id="element-56">
              Contacto
            </h4>
            <ul className="space-y-4 transition-colors duration-300" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-57">
              <li className="flex items-center gap-2" data-id="element-58">
                <Phone className="w-4 h-4 text-[#FCEE02]" data-id="element-59" />
                +1-809-247-2104
              </li>
              <li className="flex items-center gap-2" data-id="element-60">
                <Mail className="w-4 h-4 text-[#FCEE02]" data-id="element-61" />
                info@junquitogas.com
              </li>
              <li className="flex items-start gap-2" data-id="element-62">
                <MapPin className="w-4 h-4 text-[#FCEE02] mt-1" data-id="element-63" />
                <span data-id="element-64">
                  Av. Presidente Antonio Guzmán Fernández
                  <br data-id="element-65" />
                  Santiago De Los Caballeros, RD
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm transition-colors duration-300" style={{
        borderColor: 'var(--border-color)',
        color: 'var(--text-muted)'
      }} data-id="element-66">
          <p data-id="element-67">&copy; 2026 Junquito Gas. Todos los derechos reservados.</p>
          <div className="flex gap-8" data-id="element-68">
            <a href="#" className="hover:text-[#FCEE02] transition-colors" data-id="element-69">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-[#FCEE02] transition-colors" data-id="element-70">
              Términos de Servicio
            </a>
          </div>
        </div>
      </div>
    </footer>;
}